import { CodeOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Row, Col, Menu } from 'antd';
import { useState, useEffect } from 'react';
import { NavLink, Route, Switch, useLocation } from 'react-router-dom';
import { HelpDocumentsPage, ReleaseNotesPage } from '.';

export function DocumentationPage() {
  const { pathname } = useLocation();
  const [path, setPath] = useState('');

  useEffect(() => {
    let path = '/admin';
    if (pathname === path) {
      path += '/documents';
    } else {
      path += '/' + pathname.split('/')[2];
    }
    setPath(path);
  }, [pathname]);

  const links = [
    {
      path: '/documentation/help',
      text: 'Yardım',
      icon: <QuestionCircleOutlined />,
    },
    {
      path: '/documentation/release-notes',
      text: 'Sürüm notları',
      icon: <CodeOutlined />,
    },
  ];

  return (
    <Row>
      <Col span={6} xs={24} sm={24} md={6} lg={6} xl={5} xxl={4}>
        <Menu mode="inline" selectedKeys={[path]} style={{ paddingBottom: '3rem' }}>
          <Menu.ItemGroup title="Dokümantasyon">
            {links.map(l => (
              <Menu.Item key={l.path} icon={l.icon}>
                <NavLink to={l.path}>{l.text}</NavLink>
              </Menu.Item>
            ))}
          </Menu.ItemGroup>
        </Menu>
      </Col>
      <Col span={18} xs={24} sm={24} md={18} lg={18} xl={19} xxl={20}>
        <Switch>
          <Route exact path="/documentation" component={HelpDocumentsPage} />
          <Route exact path="/documentation/help" component={HelpDocumentsPage} />
          <Route exact path="/documentation/release-notes" component={ReleaseNotesPage} />
        </Switch>
      </Col>
    </Row>
  );
}
